/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum Plaatsingstatus {
    DEFINITIEF = "Definitief",
    VOORLOPIG = "Voorlopig"
}
